/**
 * Dynamic content is a place holder to use dynamically to inject components on runtime
 */
import {Directive, ViewContainerRef} from '@angular/core';

@Directive({
	selector: '[cvDynamicContent]',
})
export class DynamicContentDirective {
	constructor(public viewContainerRef: ViewContainerRef) {
	}
}
